import React, { useCallback, useState } from 'react';
import Button from 'rsuite/Button';

import { useTracking } from '../../hooks';

import './cookie-banner.scss';

const CookieBanner = () => {
  const { getCookieConsent, setCookieConsent } = useTracking();
  const [showBanner, setShowBanner] = useState(getCookieConsent() === 'undecided');
  const acceptCookies = useCallback(
    () => {
      setShowBanner(false);
      setCookieConsent(true);
    },
    [setCookieConsent]
  );
  const declineCookies = useCallback(
    () => {
      setShowBanner(false);
      setCookieConsent(false);
    },
    [setCookieConsent]
  );

  if (showBanner) {
    return (
      <div className="lf-cookie-banner">
        <p>
          We use cookies to enhance your browsing experience and analyze our traffic.
          By clickng "Accept cookies", you consent to our use of cookies.
          See our <a href="/privacy">privacy page</a>
        </p>
        <div className="buttons">
        <Button
          type="button"
          appearance="primary"
          size="xs"
          onClick={acceptCookies}>Accept cookies</Button>
        <Button
          appearance="primary"
          type="button"
          size="xs"
          onClick={declineCookies}
        >Decline cookies</Button>
        </div>
      </div>
    );
  }
  return <></>;
};

export { CookieBanner };
